/* eslint-disable camelcase */
import * as loginService from '../services/login';
import * as commService from '../../../services/commService';
import { setToken } from '@/utils/token';
import webStorage from '@/utils/storageManager';
import { MENU_CONFIG } from '@/constants';
import routes from '../../../../routes';

export default {
  namespace: 'login',

  state: {},

  effects: {
    *fetchLogin(
      {
        payload: { username, password, isQrLogin, appid, agentid, code },
        callback,
      },
      { call },
    ) {
      const loginRes = yield call(
        loginService.getLogin,
        username,
        password,
        isQrLogin,
        appid,
        agentid,
        code,
      );
      console.log('*fetchLogin -> loginRes', loginRes);
      if (loginRes) {
        setToken(loginRes);
        webStorage.delete('DEFAULT_MENU');
        // const [userRes, dictRes] = yield all([
        //   call(loginService.getUser, loginRes?.user_id),
        //   call(commService.getDictAll),
        // ]);

        const routesArray = routes[0].routes;

        let urlMap = {};

        const collectMenu = ({ items }) => {
          return items.reduce((collect, item) => {
            if (item.items) {
              collectMenu({ items: item.items });
            }
            // eslint-disable-next-line no-unused-vars
            const { items: for_exclude, ...restProps } = item;
            //菜单能够匹配到路由配置的是可访问路由
            const routeInfo = routesArray.find(
              (route) => route.path === item.href,
            );
            urlMap[item.href] = {
              ...restProps,
              isLink: Boolean(routeInfo),
            };
            return collect;
          }, []);
        };

        MENU_CONFIG.map((item) => collectMenu({ items: item.items }));
        // console.log('URL_MENU:', urlMap);
        webStorage.set('URL_MENU', urlMap);

        const userRes = yield call(loginService.getUser, loginRes?.user_id);
        webStorage.set('USER', userRes?.data);
        webStorage.set('TENANT_ID', loginRes?.tenant_id);

        // 用户菜单权限
        const userAuths = userRes?.data?.authorities || [];
        const hasAuthLinkMenu = [];

        if (userAuths.length) {
          if (userAuths.includes('MENU_SY_SALES_RANKING')) {
            const linkMenu = Object.values(urlMap).find((menu) => {
              return menu.isLink && menu?.auth === 'MENU_SY_SALES_RANKING';
            });
            // 用户有权限并可访问的路由菜单
            linkMenu && hasAuthLinkMenu.push(linkMenu);
          } else if (userAuths.includes('MENU_EC_DASHBOARD')) {
            const linkMenu = Object.values(urlMap).find((menu) => {
              return menu.isLink && menu?.auth === 'MENU_EC_DASHBOARD';
            });
            // 用户有权限并可访问的路由菜单
            linkMenu && hasAuthLinkMenu.push(linkMenu);
          } else if (userAuths.includes('MENU_EC_UGC_DASHBOARD')) {
            const linkMenu = Object.values(urlMap).find((menu) => {
              return menu.isLink && menu?.auth === 'MENU_EC_UGC_DASHBOARD';
            });
            // 用户有权限并可访问的路由菜单
            linkMenu && hasAuthLinkMenu.push(linkMenu);
          } else {
            let linkMenu;
            for (let v of Object.values(urlMap)) {
              if (
                userAuths.includes(v.auth) &&
                v.isLink &&
                !v.isHide &&
                !v.firstNav
              ) {
                linkMenu = v;
                break;
              }
            }
            // 用户有权限并可访问的路由菜单
            linkMenu && hasAuthLinkMenu.push(linkMenu);
          }
        } else {
          const linkMenu = Object.values(urlMap).find((menu) => {
            return menu?.auth === 'MENU_MY_TASK';
          });
          // 用户有权限并可访问的路由菜单
          linkMenu && hasAuthLinkMenu.push(linkMenu);
        }
        // 将第一个菜单的路由作为默认路由
        // console.log('hasAuthLinkMenu:', hasAuthLinkMenu);
        webStorage.set('DEFAULT_MENU', hasAuthLinkMenu[0]);

        const dictRes = yield call(commService.getDictAll);

        if (callback && typeof callback === 'function') {
          return callback({ loginRes, userRes, dictRes });
        }
      }
    },
    // *fetchLoginUser({ payload, callback }, { call, put }) {
    //   const result = yield call(loginService.getUserInfo);

    //   if (callback && typeof callback === 'function') {
    //     callback(result);
    //   }
    // },
    // *logout(_, { call, put }) {
    //   localStorage.clear();
    //   sessionStorage.clear();
    //   //回登录画面
    //   yield put(routerRedux.push('/login'));
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
